export enum InterventionActions {
  PageChange = 'pageChange'
}
